import React from 'react'
import { connect, useDispatch } from 'react-redux'

import css from './NotificationQueue.module.scss'

import Notification from './Notification/Notification'
import { removeNotification } from '../../../redux/actions'

const NotificationQueue = (props) => {
  const dispatch = useDispatch()

  return (
    <div className={css.NotificationQueue}>
      {props.ui.notificationQueue.map((n) => (
        <Notification
          key={n.guid}
          message={n.message}
          guid={n.guid}
          time={n.time}
          error={n.error}
          removeNotification={() => dispatch(removeNotification(n.guid))}
        />
      ))}
    </div>
  )
}

export default connect((state) => {
  return state
}, {})(NotificationQueue)
